export const BASEPATH = process.env.REACT_APP_BASE_PATH;
export const DAO_DIGIO_URL = process.env.REACT_APP_DAO_DIGIO_URL;

export const StaticRouterLinks = {
  home: "/",
  loginOTP: "/ucc-otp",
  document: "/document",
};
